import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.306 5H2.694C2.311 5 2 4.664 2 4.25s.31-.75.694-.75h18.612c.383 0 .694.336.694.75s-.311.75-.694.75m0 7.5H2.694c-.383 0-.694-.336-.694-.75s.31-.75.694-.75h18.612c.383 0 .694.336.694.75s-.311.75-.694.75m0 7.5H2.694C2.311 20 2 19.664 2 19.25s.31-.75.694-.75h18.612c.383 0 .694.336.694.75s-.311.75-.694.75"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
